import { render } from "./EmployeeDetailsView.vue?vue&type=template&id=142641be&scoped=true"
import script from "./EmployeeDetailsView.vue?vue&type=script&lang=js"
export * from "./EmployeeDetailsView.vue?vue&type=script&lang=js"

import "./EmployeeDetailsView.vue?vue&type=style&index=0&id=142641be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-142641be"]])

export default __exports__